export enum DistributionStatus {
    Created, Initialized, Registering, Completed
}



// WEBPACK FOOTER //
// ./src/app/modules/domain/enums/distribution-status.ts